export const INVOICE_DOWNLOAD_SERVICE_DETAIL_LINK_REBRAND =
  'https://biz.moneyforward.com/ai-agent/ai-billing/invoice-download/';
export const AI_AGREEMENT_URL = 'https://biz.moneyforward.com/ai-agreement/';
export const PAYMENT_REQUEST_SUPPORT_AGENT_DETAIL_LINK =
  'https://biz.moneyforward.com/ai-agent/ai-expense/payment-request-support/';
